import type { Team, TeamFormValues } from '../../model/interfaces'
import type { ApiResponse } from '@shared/api'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

import { useTeamsStore } from '../../model/teams/store'

interface TeamSaveOptions {
  teamId: string | number
  payload: TeamFormValues
}

/**
 * `PATCH /admin-api/teams/{team}` — update a team's name and member list.
 */
export const useTeamSave = async (options: TeamSaveOptions): Promise<Team | null> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()
  const store = useTeamsStore()

  const url = useAdminRoutes('admin.teams.update', { team_id: options.teamId })

  store.setSaving(true)

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return null
    }

    const { data } = await $axios.patch<ApiResponse>(url, options.payload)

    if (!data.success) {
      toast.error(data.message)
      return null
    }

    toast.success(data.message)

    return data.data || null
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))
    return null
  } finally {
    store.setSaving(false)
  }
}
